import React from 'react';
import Skeleton from './Skeleton';

const SkeletonCard = ({ className = '', children, ...props }) => {
  return (
    <div className={`skeleton-card ${className}`} {...props}>
      {children || (
        <>
          <Skeleton variant="text" className="title" />
          <Skeleton variant="text" className="medium" />
          <Skeleton variant="text" className="short" />
        </>
      )}
    </div>
  );
};

export default SkeletonCard;
